import React, {useEffect, useState} from "react";
import styled from "styled-components";
import { useNavigate} from "react-router-dom";
import { Table, TableColumnsType } from "antd";
import usePortalService from "../../services/PortalService";
import { RegistrationLinkInfo } from "../../Components/Modals/RegistrationLinkInfo";
import { Button } from "react-bootstrap";
import { AdminNavbar } from "../../Components/Navbars";

const Container = styled.div`
  width: 100%;
  padding-left: 6%;
  padding-right: 6%;
  padding-top: 42.6px;
`

const Text = styled.p<{color?: string}>`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${props => props.color ?? "#45505A"}
`

interface RegistrationLinkInfo {
  token: string
  type: string
  description: string
}

export const RegistrationLinks = () => {
  const {listRegistrationLinks} = usePortalService();
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('');

  const [registrationLinks, setRegistrationLinks] = useState([]);

  const [isLoaded, setIsLoaded] = useState(false);

  const columns: TableColumnsType<RegistrationLinkInfo> = [
    {
      title : "Описание",
      key : "description",
      width : "20.1%",
      dataIndex : "token",
      render : (_, {token, description}) =>
        <div>
          <Text>{description}</Text>
          <Text>{'https://rtsimpro.ru/registration/'+token}</Text>
        </div>
    },
    {
      title : "Скопировать",
      key : "token",
      width : "13.3%",
      render: (link) => <Button onClick={() => showInfoLink(link.token)}> Скопировать </Button>
    },
    {
      title : "Тип ссылки",
      key : "type",
      width : "23%",
      dataIndex : "type",
      render : (type) => {
        switch (type) {
          case 0:
            return <Text>Событие</Text>
          case 1:
            return <Text>Индивидуальная</Text>
          case 2:
          default:
            return <Text>Если видите этот текст, значит я накосячил. Напишите об этом мне.</Text>
        }
      }
    },
    {
      title : "Количество зарегистрировавшихся",
      key : "countRegistered",
      width : "6.6%",
      dataIndex: "countRegistered",
      render: (countRegistered) => <Text> {countRegistered} </Text>
    },
    {
      title : "Дата истечения",
      key : "expires",
      width : "13.3%",
      dataIndex: "expires",
    },
    {
      title : "Статус",
      key : "isValid",
      width : "13.3%",
      dataIndex: "isValid",
      render: (isValid) => <>{
        (isValid) ? 
        <Text color="#29A340"> Активная </Text> : 
        <Text color="#F34921"> Не рабочая</Text>
      }</>
    }
  ]

  useEffect(() => {
    listRegistrationLinks().then(result => {
      if (result.success) {
        setRegistrationLinks(result.registrationLinks);
        setIsLoaded(true);
      }
    })
  }, []);

  const navigate = useNavigate();

  const createRegistrationLinkHandler = async () => {
    navigate("/createRegistrationLink");
  }

  const showInfoLink = (link: string) => {
    setActiveLink("https://rtsimpro.ru/registration/"+link);
    setIsModalOpen(true);
  }

  const closeModalHandler = () => {
    setIsModalOpen(false);
  }

  return(
    <>
      <AdminNavbar />
      <Container>
        <div className="pair-text-button">
            <h1 style={{marginBottom : "16px"}}>Ссылки на регистрацию</h1>
            <div className="button-in-pair">
                <Button style={{height: '32px', width:'108px'}} onClick={createRegistrationLinkHandler}> + Создать </Button>
            </div>
        </div>
            {(isLoaded) && 
            <Table
              columns={columns}
              dataSource={registrationLinks} 
              pagination={false} 
              style={{marginBottom:'32px'}}
            />
            }
      </Container>
      <RegistrationLinkInfo 
        onClose={closeModalHandler} 
        isOpen={isModalOpen} 
        link={activeLink} 
        headline="Адрес ссылки для регистрации"
      />
    </>
  )
}